import { Component } from '@angular/core';

@Component({
  selector: 'app-contract-workflow-page',
  template: `
    <div class="cw-page">
      <div class="cw-page__header">
        <span class="material-icons">approval</span>
        <h1>Contract Workflow Tasks</h1>
      </div>

      <!-- ── Row 1: Tasks assigned to me ── -->
      <div class="cw-page__columns">
        <div class="cw-page__col">
          <app-contract-workflow-list
            taskType="REVIEW"
            title="Pending Review"
            mode="assigned">
          </app-contract-workflow-list>
        </div>
        <div class="cw-page__col">
          <app-contract-workflow-list
            taskType="APPROVAL"
            title="Pending Signature"
            mode="assigned">
          </app-contract-workflow-list>
        </div>
        <div class="cw-page__col">
          <app-contract-workflow-list
            taskType="ARCHIVE"
            title="Pending Archive"
            mode="assigned">
          </app-contract-workflow-list>
        </div>
      </div>

      <!-- ── Row 2: Workflows I initiated ── -->
      <div class="cw-page__section-label">
        <span class="material-icons">send</span>
        Initiated by Me
      </div>
      <div class="cw-page__initiated">
        <app-contract-workflow-list
          title="Workflows I Started"
          mode="initiated">
        </app-contract-workflow-list>
      </div>

    </div>
  `,
  styles: [`
    .cw-page { padding: 24px; background: #f4f7fb; min-height: 100vh; }

    .cw-page__header {
      display: flex; align-items: center; gap: 10px; margin-bottom: 24px;
    }
    .cw-page__header h1 { font-size: 20px; color: #1B3A6B; margin: 0; }
    .cw-page__header .material-icons { color: #4A90D9; font-size: 28px; }

    /* Top 3-column row */
    .cw-page__columns {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 16px;
      margin-bottom: 24px;
    }
    @media (max-width: 900px) { .cw-page__columns { grid-template-columns: 1fr; } }

    .cw-page__col {
      background: #fff;
      border-radius: 8px;
      border: 1px solid #e0e8f4;
      box-shadow: 0 2px 6px rgba(0,0,0,.05);
      overflow: hidden;
    }

    /* Initiated section label */
    .cw-page__section-label {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      font-weight: 700;
      color: #1B3A6B;
      margin-bottom: 12px;
    }
    .cw-page__section-label .material-icons {
      font-size: 18px;
      color: #4A90D9;
    }

    /* Full-width initiated row */
    .cw-page__initiated {
      background: #fff;
      border-radius: 8px;
      border: 1px solid #e0e8f4;
      box-shadow: 0 2px 6px rgba(0,0,0,.05);
      overflow: hidden;
    }
  `]
})
export class ContractWorkflowPageComponent {}